<!--  -->
<template>
  <a-form layout="vertical">
    <!--投票-->
    <template v-if="select.type == '1'">
      <a-form-item label="积分变动:">
        <a-input v-model:value="select.depletePoints" placeholder="请输入积分变动" />
      </a-form-item>
      <a-form-item label="礼包ID:" placeholder="请输入礼包ID">
        <a-input v-model:value="select.giftId" />
      </a-form-item>
      <a-form-item>
        <label slot="label">
          <a-badge dot>
            <span class="labelClass">投票描述:</span>
          </a-badge>
        </label>
        <a-input v-model:value="select.description" placeholder="用于展示数据统计的配置" />
      </a-form-item>
      <a-form-item label="投票频次限制:">
        <a-switch v-model:checked="select.limitStatus" />
      </a-form-item>
      <a-form-item v-if="select.limitStatus">
        <label slot="label">
          <a-badge dot>
            <span class="labelClass">每天可投票次数:</span>
          </a-badge>
        </label>
        <a-input v-model:value="select.dayLimitTimes" placeholder="用于限制投票次数" />
      </a-form-item>
    </template>
    <!--邀请好友-->
    <template v-if="select.type == '4'">
      <a-form-item :label="select.inviteType == 2 ? '' : '邀请数量'">
        <label slot="label" v-if="select.inviteType == 2">
          <a-badge dot>
            <span class="labelClass">邀请数量:</span>
          </a-badge>
        </label>
        <a-input v-model:value="select.counts" placeholder="请输入大于等于0的数字" />
      </a-form-item>
      <a-form-item :label="select.inviteType == 2 ? '' : '礼包ID'">
        <label slot="label" v-if="select.inviteType == 2">
          <a-badge dot>
            <span class="labelClass">礼包ID:</span>
          </a-badge>
        </label>
        <a-input v-model:value="select.giftId" placeholder="用户通过参与此活动进行礼品发放" />
      </a-form-item>
    </template>
    <!--答题-->
    <template v-if="select.type == '3'">
      <a-form-item label="增加积分:">
        <a-input v-model:value="select.addtionPoints" placeholder="请输入增加积分" />
      </a-form-item>
      <a-form-item label="礼包ID:">
        <a-input v-model:value="select.giftId" placeholder="请输入礼包ID" />
      </a-form-item>
      <a-form-item>
        <label slot="label">
          <a-badge dot>
            <span class="labelClass">答题描述:</span>
          </a-badge>
        </label>
        <a-input v-model:value="select.description" placeholder="用于展示数据统计的配置" />
      </a-form-item>
      <a-alert message="提示" description="答题的开始时间和结束时间需要在活动时间范围内!" type="info" show-icon>
        <template #icon>
          <smile-outlined />
        </template>
      </a-alert>
      <a-form-item label="答题开始时间:">
        <a-date-picker
          v-model:value="select.startTimeText"
          :show-time="{ format: 'HH:mm' }"
          format="YYYY-MM-DD HH:mm"
          placeholder="请输入开始时间"
          @change="datepcikerStartChange($event,selec)"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="答题结束时间:">
        <a-date-picker
          v-model:value="select.endTimeText"
          :show-time="{ format: 'HH:mm' }"
          format="YYYY-MM-DD HH:mm"
          placeholder="请输入结束时间"
          @change="datepcikerEndChange($event,select)"
          style="width: 100%"
        />
      </a-form-item>
    </template>
    <!--抽奖-->
    <template v-if="select.type == '2'">
      <a-form-item>
        <label slot="label">
          <span class="labelClass">
            <a-badge dot>
              <span>中奖概率:</span>
            </a-badge>
            <a-tooltip>
              <Icon :icon="'question-line'" class="icon" />
              <template #title>输入的数字占所有节点数字总和的百分比</template>
            </a-tooltip>
          </span>
        </label>
        <a-input v-model:value="select.winningWeight" placeholder="请输入大于等于0的数字" type="number" />
      </a-form-item>
      <a-form-item v-if="select.lotteryType === 1">
        <label slot="label">
          <span class="labelClass">
            <a-badge dot>
              <span>未中奖概率:</span>
            </a-badge>
            <a-tooltip>
              <Icon :icon="'question-line'" class="icon" />
              <template #title>当前节点，中奖概率输入的值/中奖概率加未中奖概率输入值的和</template>
            </a-tooltip>
          </span>
        </label>
        <a-input v-model:value="select.unwinningWeight" placeholder="请输入大于等于0的数字" type="number" />
      </a-form-item>
      <a-form-item label="消耗积分:" v-if="select.lotteryType == 1">
        <a-input v-model:value="select.depletePoints" placeholder="请输入消耗积分" />
      </a-form-item>
      <a-form-item label="奖品总数:" v-if="select.lotteryType == 1">
        <a-input v-model:value="select.total" placeholder="请输入奖品总数" />
      </a-form-item>
      <a-form-item label="礼包ID:">
        <a-input v-model:value="select.giftId" placeholder="请输入礼包ID" />
      </a-form-item>

      <a-form-item label="用户中奖次数:">
        <a-input v-model:value="select.timesLimit" placeholder="请输入中奖次数" />
      </a-form-item>
      <a-form-item label="奖品:">
        <a-input v-model:value="select.reward" placeholder="请输入奖品"/>
      </a-form-item>
      <a-form-item>
        <label slot="label">
          <span class="labelClass">
            <a-badge dot>
              <span>抽奖描述:</span>
            </a-badge>
          </span>
        </label>
        <a-input v-model:value="select.description" placeholder="用于展示数据统计的配置" />
      </a-form-item>
      <a-form-item v-if="select.lotteryType == 1">
        <div class="labelClass" slot="label">
          <span>单位时间放票数量:</span>

          <a-tooltip>
            <Icon :icon="'question-line'" />
            <template #title>防止参与用户数量过多时，过多消耗奖品总数量</template>
          </a-tooltip>
          <a-button
            type="primary"
            size="small"
            class="card-btn"
            @click.capture="addLimitCardChange(select)"
          >
            <template #icon>
              <Icon :icon="'add-circle-line'" />
            </template>
            添加
          </a-button>
        </div>
        <a-alert message="提示" description="为了确保放票逻辑，请勿配置重叠时间!" type="info" show-icon>
          <template #icon>
            <smile-outlined />
          </template>
        </a-alert>
        <div class="limitCard" v-for="(item,index) in select.frequencyLimit" :key="index">
          <div class="card-delete">
            <Icon :icon="'delete-back-line'" @click="deleteCardChange(index)" />
          </div>
          <a-form-item label="时间:">
            <a-range-picker
              format="YYYY-MM-DD HH:mm"
              :placeholder="['Start Time', 'End Time']"
              @change="voteDateChange(item,index)"
              v-model:value="item.time"
            />
          </a-form-item>
          <a-form-item label="放票数量:">
            <a-input
              v-model:value="item.count"
              @change="voteNumberChange(item,index)"
              placeholder="请输入放票数量"
            />
          </a-form-item>
        </div>
      </a-form-item>
    </template>
  </a-form>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import Icon from "@/layout/icon";
import momentTimezone from "moment-timezone";
import { SmileOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  props: {
    select: {
      type: Object
    },
    selectRules: {
      type: Object
    }
  },
  components: {
    Icon,
    SmileOutlined
  },
  emits: ["update:select"],
  setup(props, { emit }) {
    const data = ref(props.select);
    const checked1 = ref(false);
    watch(
      () => props.select,
      val => (data.value = val)
    );
    watch(
      () => props.select.giftId,
      (giftId, prev) => {
        props.select.giftId =
          giftId && String(giftId).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.addtionPoints,
      (addtionPoints, prev) => {
        props.select.addtionPoints =
          addtionPoints && String(addtionPoints).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.dayLimitTimes,
      (dayLimitTimes, prev) => {
        props.select.dayLimitTimes =
          dayLimitTimes && String(dayLimitTimes).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.timesLimit,
      (timesLimit, prev) => {
        props.select.timesLimit =
          timesLimit && String(timesLimit).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.winningWeight,
      (winningWeight, prev) => {
        console.log(winningWeight, "winningWeight");
        props.select.winningWeight =
          winningWeight && String(winningWeight).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.unwinningWeight,
      (unwinningWeight, prev) => {
        props.select.unwinningWeight =
          unwinningWeight &&
          String(unwinningWeight).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.total,
      (total, prev) => {
        props.select.total =
          total && String(total).replace(/^(\-+)|[^\d]+/g, "");
      }
    );
    watch(
      () => props.select.depletePoints,
      (depletePoints, prev) => {
        props.select.depletePoints =
          depletePoints && String(depletePoints).replace(/^[^\d,-]+/g, "");
      }
    );
    const voteNumberChange = (item, index) => {
      console.log(item, index, "00000");
      item.count =
        item.count && String(item.count).replace(/^(\-+)|[^\d]+/g, "");
    };
    const addLimitCardChange = select => {
      select.frequencyLimit.push({
        time: [],
        count: ""
      });
    };
    const deleteCardChange = index => {
      props.select.frequencyLimit.splice(index, 1);
    };
    const datepcikerStartChange = (date, item) => {
      console.log(date, "/////");
      console.log(item, "itememtm");
      emit("datepcikerStartChange", date, item);
    };
    const datepcikerEndChange = (date, item) => {
      console.log(date, "/////");
      console.log(item, "itememtm");
      emit("datepcikerEndChange", date, item);
    };
    const voteDateChange = (item, index) => {
      console.log(item, "选择了");
      // momentTimezone.tz.setDefault(find.value);
      // item.startTime =  momentTimezone(item.time[0]).unix()
      emit("voteDateChange", item, index);
    };
    return {
      data,
      addLimitCardChange,
      checked1,
      deleteCardChange,
      datepcikerStartChange,
      datepcikerEndChange,
      voteDateChange,
      voteNumberChange
    };
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.icon {
  margin-left: 10px;
}
.labelClass {
  padding-bottom: 10px;
  color: #313131;
  #flex-box.row-start-c();
}
.limitCard {
  #flex-box.column-n-n();
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 10px;
  margin-top: 10px;
}
.card-btn {
  #flex-box.row-c-c();
  margin-left: 15px;
  border-radius: 10px;
}
.card-delete {
  #flex-box.row-e();
}
</style>